export type CoreService = {
  slug: string;
  title: string;
  summary: string;
  offerings: string[];
  benefits: string[];
};

export const coreServices: CoreService[] = [
  {
    slug: "nurse-services",
    title: "Nurse Services",
    summary:
      "Professional nursing care delivered in the comfort of home by compassionate, qualified healthcare staff.",
    offerings: [
      "Home patient care",
      "Post-surgery care",
      "Injection and medication support",
      "Elderly nursing care",
      "ICU and recovery support",
      "Vital monitoring",
      "Wound and catheter care",
      "Bedridden care",
      "Diabetes and blood pressure monitoring",
      "Palliative and chronic care",
    ],
    benefits: [
      "Personalized medical attention at home",
      "Reduced hospital visits where home care is suitable",
      "Recovery support in a familiar environment",
      "Flexible nursing support options",
      "Experienced and verified nurses",
    ],
  },
  // {
  //   slug: "care-coordinator-services",
  //   title: "Care Coordinator Services",
  //   summary:
  //     "Dedicated coordinators manage the complete care journey for elderly individuals and their families.",
  //   offerings: [
  //     "Elderly care support",
  //     "Doctor appointment support",
  //     "Hospital coordination",
  //     "Family health updates",
  //     "Medicine delivery support",
  //     "Test and report management",
  //     "Emergency care support",
  //     "Personalized care planning",
  //   ],
  //   benefits: [
  //     "Hassle-free healthcare coordination",
  //     "Better communication and transparency",
  //     "Timely medical support and follow-up",
  //     "Reduced stress for family members",
  //     "Continuous monitoring of elderly care needs",
  //   ],
  // },
  // {
  //   slug: "tele-health-services",
  //   title: "Tele Health Services",
  //   summary:
  //     "Convenient virtual healthcare support that helps patients and seniors stay connected from home.",
  //   offerings: [
  //     "Online care guidance",
  //     "Home and online physiotherapy coordination",
  //     "Remote follow-up support",
  //     "Care plan review assistance",
  //     "Family consultation support",
  //   ],
  //   benefits: [
  //     "Accessible healthcare support from home",
  //     "Flexible follow-up care",
  //     "Improved continuity between in-person and virtual care",
  //     "Less travel burden for seniors and families",
  //   ],
  // },
  // {
  //   slug: "companion-caregiver-services",
  //   title: "Companion Caregiver Services",
  //   summary:
  //     "Compassionate caregivers provide emotional, social, and daily living support for seniors at home.",
  //   offerings: [
  //     "Elder companionship",
  //     "Daily activity support",
  //     "Emotional wellness support",
  //     "Walking assistance",
  //     "Reading and engagement activities",
  //     "Hobby and recreation support",
  //     "Meal-time companionship",
  //     "Medication reminders",
  //     "Senior living support",
  //     "Non-medical daily assistance",
  //   ],
  //   benefits: [
  //     "Reduces loneliness and isolation",
  //     "Improves emotional well-being",
  //     "Encourages active and healthy living",
  //     "Provides comfort and companionship",
  //     "Enhances confidence and independence",
  //     "Peace of mind for family members",
  //   ],
  // },
];

export const careNeedOptions = coreServices.map((service) => service.title);

export function getCoreServiceBySlug(slug: string) {
  return coreServices.find((service) => service.slug === slug);
}
